import { api } from '@/lib/api';

// Il report può richiedere >60s: il backend risponde {pending:true} e qui ripetiamo la POST finché è pronto.
export async function generateLandIntel(listingId, force = false) {
  let body = { force_refresh: force };
  for (let i = 0; i < 6; i++) {
    const { data } = await api.post(`/land-intel/${listingId}`, body, { timeout: 70000 });
    if (!data?.pending) return data;
    body = { force_refresh: false };
  }
  throw new Error('Il report sta richiedendo più tempo del previsto, riprova tra un minuto.');
}
